var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-box as-flex main-between cross-center" },
    [
      _c("div", { staticClass: "title as-flex main-center cross-center" }, [
        _vm._v(_vm._s(_vm.reportInfo.name)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "as-flex main-center cross-center" },
        [
          _c(
            "el-button",
            { staticClass: "download-btn", on: { click: _vm.download } },
            [
              _vm._v("\n      下载报告\n      "),
              _c("i", { staticClass: "el-icon-download el-icon--right" }),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }